// Expect params fromPast/fromFuture (year in digit) e.g 18, 2, 10
const dateRange = () => {
  let date = new Date();
  const monthIndex = date.getMonth();
  const dayIndex = date.getDate();

  const getDateRange = (fromPast, fromFuture) => {
    let startFrom = date.getFullYear();
    if (fromPast > 0) {
      startFrom = date.getFullYear() - parseInt(fromPast);
    } else if (fromFuture > 0) {
      startFrom = date.getFullYear() + parseInt(fromPast);
    }
    return new Date(startFrom, monthIndex, dayIndex);
  };
  // const [startDate, setStartDate] = useState(new Date(startFrom, monthIndex, dayIndex));

  return [date, getDateRange];
};

export default dateRange;
